import get from 'lodash/get';

export const Attachment = data => ({
  id: data.id,
  type: data.type,
  name: data.name,
  contentType: data.contentType,
  contentLength: data.contentLength,
  url: data.url,
  fields: data.fields,
  preview: data.preview,
});

export const responseDataToAttachment = responseData => {
  return new Attachment({
    id: get(responseData, 'data.data.id'),
    type: get(responseData, 'data.data.type'),
    name: get(responseData, 'data.data.attributes.name'),
    contentType: get(responseData, 'data.data.attributes.contentType'),
    contentLength: get(responseData, 'data.data.attributes.contentLength'),
    url: get(responseData, 'data.meta.upload.url'),
    fields: get(responseData, 'data.meta.upload.fields'),
    preview: get(responseData, 'data.data.links.related'),
  });
};
